import React, {
    useContext
} from "react";
import {
    CategoryPageContext
} from "../../context/CategoryPageManager";
import Skeleton from "react-loading-skeleton";
import ReactMarkdown from "react-markdown";

function CategoryPageTitle() {
    const categoryContext = useContext(CategoryPageContext);
    return (
        <div className="mt-5 mb-5">
            { categoryContext.category ? (
                <React.Fragment>
                    <h1>{ categoryContext.category.name }</h1>
                    <ReactMarkdown>
                        { categoryContext.category.description }
                    </ReactMarkdown>
                </React.Fragment>
            ) : (
                <React.Fragment>
                    <h1><Skeleton width={ 300 }/></h1>
                    <Skeleton count={ 3 }/>
                </React.Fragment>
            )}
        </div>
    )
}

export default React.memo(CategoryPageTitle);
